<template>
  <div class="footer">
    <div class="footerNav">
      <p class="footerNavTitle clear">商务合作</p>
      <p class="footerNavDesc clear">BUSINESS COOPERATION</p>
      <div class="footerNavBot">
        <ul class="footerNavBotCom">
          <li class="comList" v-for="(item, index) in comArr" :key="index">
            <img class="comListImg" :src="item.icon" alt="logo" />
            <p class="comListTitle clear">{{ item.title }}</p>
            <p class="comListDesc clear">{{ item.desc }}</p>
          </li>
        </ul>
        <div class="footerNavBotQr">
          <div class="qrList" v-for="(item, index) in qrArr" :key="index">
            <img class="qrListImg" :src="item.qr" alt="二维码" />
            <p class="qrListTitle clear">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="footerNavLine"></div>
    </div>
  </div>
</template>

<script setup>
const comArr = [
  {
    icon: 'https://p1.ssl.qhimg.com/t01ac02256b3ce23906.png',
    title: '联系人',
    desc: '马欣'
  },
  {
    icon: 'https://p1.ssl.qhimg.com/t0114e36e357d20b9aa.png',
    title: 'Email',
    desc: 'ISC@360.cn'
  },
  {
    icon: 'https://p4.ssl.qhimg.com/t01933293f146ba2880.png',
    title: '电话',
    desc: '15718876610'
  }
]
const qrArr = [
  {
    qr: 'https://p2.ssl.qhimg.com/t011653222351b02f73.png',
    title: 'ISC APP下载'
  },
  {
    qr: 'https://p2.ssl.qhimg.com/t01939c2de2744eb423.png',
    title: '微信公众号'
  }
]
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.footer {
  position: relative;
  width: 100%;
  height: 313px;
  background: #000;
  &Nav {
    position: absolute;
    top: -68px;
    left: 50%;
    transform: translateX(-50%);
    width: 793px;
    height: 292px;
    border-radius: 8px;
    background: #fcfcfc;
    padding: 32px 0 0 61px;
    color: #3d3d3d;
    &Title {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      margin: 0;
    }
    &Desc {
      font-size: 14px;
      line-height: 22px;
    }
    &Bot {
      display: flex;
      justify-content: space-between;
      &Com {
        margin-top: 22px;
        // border-right: 1px solid rgba(61, 61, 61, 0.2);
      }
      &Qr {
        display: inline-block;
      }
    }
    &Line {
      position: absolute;
      top: 84px;
      left: 375px;
      width: 1px;
      height: 124px;
      background-color: rgba(61, 61, 61, 0.2);
    }
    .comList {
      list-style: none;
      display: flex;
      width: 320px;
      margin-bottom: 22px;
      &Img {
        width: 20px;
        height: 20px;
      }
      &Title {
        // width: 54px;
        margin: 0 10px 0 15px;
        font-size: 18px;
        line-height: 24px;
        color: rgba(61, 61, 61, 0.6);
      }
      &Desc {
        font-size: 18px;
        line-height: 24px;
        color: #3d3d3d;
      }
    }
    .qrList {
      display: inline-block;
      margin-right: 48px;
      text-align: center;
      &Img {
        width: 120px;
        height: 120px;
        border: 1px dashed #fcfcfc;
      }
    }
  }
}
</style>
